export const environment = {
  name: 'production',
  production: true,
  apiUrl: 'https://api.haiplay.ai',
};
